"use client"
import { isClientLoggedIn } from "@lib/data/client-cookies"
import { getIsFraudListed } from "@lib/data/customer"
import { usePathname } from "next/navigation"
import { createContext, useContext, useEffect, useState } from "react"

type FraudContextType = {
  isFraudListed: boolean | null
  loading: boolean
}

const FraudContext = createContext<FraudContextType>({
  isFraudListed: null,
  loading: true,
})

export const FraudProvider = ({ children }: { children: React.ReactNode }) => {
  const [isFraudListed, setIsFraudListed] = useState<boolean | null>(null)
  const [loading, setLoading] = useState(true)
  const pathname = usePathname()

  useEffect(() => {
    const checkFraud = async () => {
      setLoading(true)
      const loggedIn = await isClientLoggedIn()
      if (!loggedIn) {
        setIsFraudListed(null)
        setLoading(false)
        return
      }

      try {
        const flag = await getIsFraudListed()
        setIsFraudListed(
          Array.isArray(flag) && flag.length === 0 ? false : flag
        )
      } catch {
        setIsFraudListed(null)
      } finally {
        setLoading(false)
      }
    }

    checkFraud()
  }, [pathname]) // Re-run when pathname changes

  return (
    <FraudContext.Provider value={{ isFraudListed, loading }}>
      {children}
    </FraudContext.Provider>
  )
}

export const useFraud = () => useContext(FraudContext)
